import stylesheet from './ArticleContent.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

export class NXTArticleContent extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const articleContainer = document.createElement('article');
        articleContainer.classList.add('article');
        articleContainer.innerHTML = `
            <div class="article-content">
                <div class="main">
                    <slot></slot>
                </div>
                <div class="faq">
                    <slot name="faq"></slot>
                </div>
            </div>
            <aside class="article-aside">
                <slot name="aside"></slot>
            </aside>
        `;
        this.setHasSlottedToParent(articleContainer);
        return articleContainer;
    }
}

customElements.define('nxt-article-content', NXTArticleContent);
